import { render, staticRenderFns } from "./edit-page.vue?vue&type=template&id=1d5b2f02&"
import script from "./edit-page.vue?vue&type=script&lang=js&"
export * from "./edit-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports